/* global document, window */

/**
 * Takes a timestamp and turns it into a human readable date string based on the
 * following criteria:
 * - Within the hour = "15 minutes ago."
 * - Within the day = "Today at 3:30pm"
 * - Other = "August 3rd, 2022"
 */
import differenceInMinutes from 'date-fns/differenceInMinutes';
import endOfYesterday from 'date-fns/endOfYesterday';
import format from 'date-fns/format';
import map from 'lodash/fp/map';
import parseISO from 'date-fns/parseISO';

const publishTime = ($) => {
  // Human readable publish time
  if (document.querySelector('.cidrap-publish-time')) {
    const updateTimes = () => {
      map((dt) => {
        const datetime = dt.getAttribute('datetime');
        const published = parseISO(datetime);
        const now = new Date();
        const diff = differenceInMinutes(now, published);
        const yesterday = endOfYesterday();
        // default format - "January 1, 2022"
        let displayValue = format(published, 'LLLL d, yyyy');
        // Set display text based on recency.
        if (diff < 0) {
          // Something for future dates.
        } else if (diff < 60) {
          // Within 60 minutes - "22 minutes ago."
          dt.classList.add('within-the-hour');
          displayValue = `${diff} minutes ago.`;
        } else {
          dt.classList.remove('within-the-hour');
          // Not within 60 minutes, but on the same day - "Today at 3:30pm"
          if (differenceInMinutes(published, yesterday) > 0) {
            const pt = format(published, 'p')
              .replace('PM', 'p.m.')
              .replace('AM', 'a.m.');
            displayValue = `Today at ${pt}`;
          }
        }
        /* eslint-disable no-param-reassign */
        dt.innerHTML = displayValue;
      }, document.querySelectorAll('.cidrap-publish-time'));
      setTimeout(updateTimes, 60000);
    };
    updateTimes();
    $(window).ajaxComplete(updateTimes);
  }
};

export default publishTime;
